// Pure string / id formatters used by the Create/Edit Event modal.

// Turn a number into a `$1,234.56` string (2-decimal rounded).
export const formatMoney = (n) =>
  `$${(Math.round((Number(n) || 0) * 100) / 100).toLocaleString()}`;

// Events use short hex tags like `[#abc12]` as both the document id and
// the URL slug. Stripping the brackets + hash gives the URL-safe version.
export const generateEventId = () => {
  const chars = "0123456789abcdef";
  let id = "";
  for (let i = 0; i < 5; i++) id += chars[Math.floor(Math.random() * chars.length)];
  return `[#${id}]`;
};

export const toUrlSafeEventId = (id) => (id || "").replace(/[[\]#]/g, "");

// Pad a Date into the yyyy-mm-dd / HH:mm strings that <input type="date|time">
// controls expect.
export const toDateInputString = (d) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const toTimeInputString = (d) => {
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}`;
};
